<template>
  <el-dialog
    title="详情"
    :visible.sync="viewVisible"
    custom-class="my-dialog-template changeTemplate"
    width="1250px"
    :close-on-click-modal="false"
    append-to-body
  >
    <el-form :inline="true" class="my-form-template" :model="searchParams">
      <el-form-item label=" 保 单 号 " prop="policyNo">
        <el-input type="text" placeholder="请输入保单号" v-model="policyNo" clearable></el-input>
      </el-form-item>

      <el-form-item label="产品名称" prop="policyNo">
        <el-input type="text" placeholder="请输入产品名称" v-model="productName2" clearable></el-input>
      </el-form-item>

      <el-form-item label="" v-if="[1, 2].includes(userinfo.userLevel) && [1, 2].includes(userinfo.level * 1)">
        <div class="cell-border">
          <el-select
            class="left-select"
            v-model="level"
            @change="
              userId = '';
              mechanId = '';
            "
            style="width: 110px"
            placeholder="出单机构"
          >
            <el-option label="出单机构" value="2"></el-option>
            <el-option label="出单员工" value="3"></el-option>
          </el-select>
          <el-select v-if="level == 2" class="right-select" v-model="mechanId" clearable filterable>
            <el-option :label="dept.shortName" :value="dept.id" v-for="(dept, index) in selectList" :key="index"></el-option>
          </el-select>
          <el-select v-else-if="level == 3" class="right-select" v-model="userId" clearable filterable>
            <el-option :label="dept.name" :value="dept.id" v-for="(dept, index) in userList" :key="index"></el-option>
          </el-select>
        </div>
      </el-form-item>

      <!-- 只有二级机构显示 -->
      <el-form-item label="出单员工" v-if="userinfo.userLevel == 3 && [2].includes(userinfo.level * 1)">
        <el-select v-model="userId" clearable filterable>
          <el-option :label="dept.name" :value="dept.id" v-for="(dept, index) in userList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="续费状态">
        <el-select v-model="renewalStatus" clearable filterable>
          <el-option label="待续费" value="1"></el-option>
          <el-option label="续费成功" value="2"></el-option>
          <el-option label="续费失败" value="3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item style="width: 18%">
        <el-button type="warning" @click="pageChange(1)" class="inquire">查询</el-button>
        <el-button class="derive-btn" type="warning" @click="exportPolicyExcel" plain>导出</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" stripe border class="list-table scroll-table" style="width: 100%" tooltip-effect="dark" ref="multipleTable" max-height="400">
      <el-table-column prop="policyNo" label="保单号" fixed="left" width="200" key="policyNo" show-overflow-tooltip></el-table-column>
      <el-table-column prop="mechanName" label="出单账户" key="mechanName" min-width="160" width="250" fixed="left" show-overflow-tooltip></el-table-column>
      <el-table-column prop="policyStatus" label="保单状态" key="policyStatus" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ all[scope.row.policyStatus] }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="productName" label="产品名称" key="productName" min-width="280" show-overflow-tooltip></el-table-column>
      <el-table-column prop="additionName" label="附加险名称" key="additionName" min-width="280" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.additionName ? scope.row.additionName : '/' }}
        </template>
      </el-table-column>
      <el-table-column prop="policyerName" label="投/被保人" key="policyerName" min-width="200" show-overflow-tooltip>
        <template slot-scope="scope"> {{ scope.row.policyerName }} / {{ scope.row.insuranceName }} </template>
      </el-table-column>
      <el-table-column prop="needPayTime" label="应续日期/宽限到期" key="needPayTime" min-width="250" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.needPayTime.split(' ')[0].replace(/-/g, '/') }} -
          {{ scope.row.lastPayTime.split(' ')[0].replace(/-/g, '/') }}
        </template>
      </el-table-column>
      <el-table-column prop="curRet" label="续费期数" key="curRet" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="settlementFee" label="结算应收保费/结算实收保费" key="settlementFee" min-width="240" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.settlementFee ? scope.row.settlementFee : 0 }} /
          {{ scope.row.settlementPayFee ? scope.row.settlementPayFee : 0 }}
        </template>
      </el-table-column>

      <el-table-column prop="renewalStatus" label="续费状态" min-width="150" key="renewalStatus" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.renewalStatus == 1">待续费</span>
          <span v-else-if="row.renewalStatus == 2">续费成功</span>
          <span v-else-if="row.renewalStatus >= 3">续费失败</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="page"
      background
      layout="total,prev, pager, next"
      @current-change="pageChange"
      :page-size="10"
      :current-page.sync="pageNum"
      :total="listCount"
    >
    </el-pagination>
  </el-dialog>
</template>
<script>
export default {
  data: () => ({
    viewVisible: false,
    policyNo: "",
    productName2: "",
    clearing: "",
    mechanId: "",
    userId: '',
    renewalStatus: "",
    searchParams: {
      //   policyNo: "",
      //   needPayDate: "",
      //   curRet: "",
      //   configCode: "",
      // pageSize: 5,
      // pageNum: 1,
    },

    pageNum: 1,
    level: "",
    selectList: [], // 出单机构
    userList: [],
    tableData: [],
    listCount: 0,
    userinfo: {},
    all: null,
  }),
  components: {},
  watch: {
    viewVisible() {
      this.policyNo = "";
      this.mechanId = "";
      this.userId = ''
      this.productName2 = this.$parent.productName;
      this.pageNum = 1;
      // this.$set(this.searchParams,'pageNum',1)
    },
  },
  created() {
    this.getUserInfo();
    this.getState();
  },
  mounted() { },
  methods: {
    getUserList() {
      this.$http({
        url: '/master/subAccount/queryUsersList',
        type: 'PUT',
        params: {}
      })
        .then(res => {
          if (res.httpCode == 200) {
            this.userList = res.data;
          }
        })
        .catch(e => { });
    },
    //获取状态
    getState: function () {
      var that = this;
      this.$tools.getall(that.setAll);
    },
    setAll: function (data) {
      this.all = data.POLICY_STATUS;
      console.log(data.POLICY_STATUS, "all");
    },
    pageChange(page) {
      this.pageNum = page;
      this.getList();
    },
    getList() {
      var params = {
        policyNo: this.policyNo ? this.policyNo : undefined,
        mechanId: this.mechanId ? this.mechanId : undefined,
        userId: this.userId ? this.userId : undefined,
        renewalStatus: this.renewalStatus ? this.renewalStatus : undefined,
        needPayDate: this.$parent.detailRow.needPayDate
          ? this.$parent.detailRow.needPayDate
          : undefined,
        configCode: this.$parent.detailRow.configCode
          ? this.$parent.detailRow.configCode
          : undefined,
        curRet: this.$parent.detailRow.payNum
          ? this.$parent.detailRow.payNum
          : undefined,
        pageNum: this.pageNum,
        rateId: this.$parent.detailRow.id,
        productName: this.$parent.productName
          ? this.$parent.productName
          : undefined,
        productName2: this.productName2 ? this.productName2 : undefined,
        pageSize: 10,
      };
      this.$http({
        url: "/master/policy/checkRenewal/list",
        type: "put",
        params: params,
      }).then((data) => {
        this.tableData = data.data;
        this.listCount = data.total;
      });
    },
    // 获取机构/员工列表
    getChildList() {
      this.$http({
        url: "/master/mechan/queryChildList",
        type: "PUT",
        params: {
          includeFirst: '1'
        }
      })
        .then((res) => {
          if (res.httpCode == 200) {
            this.selectList = res.data;
          }
        })
        .catch((e) => { });
    },
    getUserInfo() {
      const data = this.$tools.getLocal("userinfo");
      this.userinfo = this.$tools.getLocal("userinfo");
      // 1一级机构 2二级机构
      if (data.level == 1 || (data.level == 2 && data.userLevel == 2)) {
        // 一级机构默认出单机构
        this.level = "2";
        this.getChildList(); // 获取出单机构列表
        this.getUserList()
      } else if (data.level == 2) {
        //二级机构没有出单机构，默认出单员工
        this.level = "3";
        this.getUserList()
      }
    },
    //导出excel
    exportPolicyExcel() {
      var str = "";
      if (this.$parent.detailRow.needPayDate) {
        str += `needPayDate=${this.$parent.detailRow.needPayDate}&`;
      }
      if (this.$parent.detailRow.payNum) {
        str += `curRet=${this.$parent.detailRow.payNum}&`;
      }
      if (this.$parent.detailRow.configCode) {
        str += `configCode=${this.$parent.detailRow.configCode}&`;
      }
      if (this.$parent.productName) {
        str += `productName=${this.$parent.productName}&`;
      }
      if (this.productName2) {
        str += `productName2=${this.productName2}&`;
      }
      if (this.policyNo) {
        str += `policyNo=${this.policyNo}&`;
      }
      if (this.mechanId) {
        str += `mechanId=${this.mechanId}`;
      }
      if (this.userId) {
        str += `userId=${this.userId}`;
      }
      if (this.renewalStatus) {
        str += `renewalStatus=${this.renewalStatus}`;
      }

      // needPayDate=${this.$parent.detailRow.needPayDate}&curRet=${this.$parent.detailRow.payNum}&configCode=${this.$parent.detailRow.configCode}&policyNo=${this.policyNo}

      var url =
        this.$config.api_root +
        `/master/policy/checkRenewalPolicys/export?rateId=${this.$parent.detailRow.id}&` +
        str;
      this.$tools.daochu(url);
    },
  },
};
</script>
<style lang='scss' scoped>
.changeTemplate {
  .template-tab {
    .el-tabs__item {
      font-size: 14px;
    }
  }
  .tools {
    letter-spacing: 2px;
    text-align: right;
    font-size: 12px;
    line-height: 15px;
    color: #888888;
    margin-bottom: 10px;
    span {
      color: #fd9201;
    }
  }
  .list-table {
    margin-bottom: 32px;
    .el-table__row {
      height: 50px;
    }
    .cell {
      line-height: 25px;
    }
    &.scroll-table {
      &::v-deep {
        .el-table__body-wrapper {
          // max-height: 325px;
          // overflow-y: scroll;
        }
      }
    }
  }
}
// /deep/body .el-table--scrollable-y {
//   /deep/.el-table__body-wrapper::-webkit-scrollbar {
//     width: 9px;
//     height: 9px;
//   }
//   /deep/.gutter {
//     width: 10px !important;
//   }
// }
body >>> .el-table th.gutter {
  display: table-cell !important;
}
body >>> .el-table colgroup.gutter {
  display: table-cell !important;
}
/deep/.el-table__fixed-body-wrapper {
  bottom: 0;
}
.inquire {
  width: 80px;
  height: 32px;
  padding: 0px;
  background: #f47900 !important;
}
.derive-btn {
  // position: absolute;
  // top: 0;
  // right: 0;
  width: 80px;
  height: 32px;
  padding: 0px;

  margin-bottom: 10px;
  color: #fd9201 !important;
  background-color: #ffffff !important;
  border-color: #fd9201 !important;

  &:hover {
    background-color: #fd9201 !important;
    border-color: #fd9201 !important;
    color: #ffffff !important;
  }
}
.cell-border {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  line-height: 0;
}
.left-select {
  &/deep/.el-input__inner {
    border-right: 1px solid #dcdfe6;
    border-top: none;
    border-bottom: none;
    border-left: none;
    border-radius: 4px 0 0 4px;
  }
}
.right-select {
  width: calc(100% - 110px) !important;
  &::v-deep {
    .el-input__inner:focus {
      border-color: #dcdfe6;
    }
    .is-focus {
      .el-input__inner {
        border-color: #dcdfe6;
      }
    }
  }
  &/deep/.el-input__inner {
    border: none;
    border-radius: 4px 0 0 4px;
  }
}
</style>